/* Component Dependencies */
var familyActivitiesTemplate = require('templates/familyActivities.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'familyActivities',
  template: {
    'familyActivities': familyActivitiesTemplate
  }
});
